

<main class="page-main">

  <div class="container layout layout--modal">
    <div class="layout__row">
      <div class="layout__sidecol">
        <div class="layout__sidecolinner">
          <div class="card card--menu">
            <div class="card-body card-body-edit">

              @if (isSidebarLoading) {
                @for (i of [1,2,3]; track i) {
                  <div class="loading-skeleton">
                    <div class="loading-skeleton__inner">
                      <div class="loading-skeleton__content">
                        <div class="loading-skeleton__title"></div>
                        <div class="loading-skeleton__text"></div>
                        <div class="loading-skeleton__text"></div>
                      </div>
                    </div>
                  </div>
                }
              }

              @if (!isSidebarLoading) {
                @for (item of event_details?.items; track item) {
                  <div class="claim-summary-card claim-summary-card--sm" (click)="activateItem(item)"
                    [ngClass]="{'claim-summary-card--active': cart_item?.class_id === item?.class_id && cart_item?.entry_type != 'police_report_details'}">
                    <div class="claim-summary-card__image">
                      <img src="assets/img/claims/event-crash-temp.svg" class="icon">
                      <img src="assets/3/icn/claims-shield.svg" class="icon-secondary">
                    </div>
                    <div class="progress-tree__detail-description">
                      <h5 class="text-color-dark mb-4">{{item.name}}</h5>
                      <p>{{item.location}}</p>
                      <p class="progress-tree__detail-date">{{item.date}}</p>
                    </div>
                    <div class="progress-tree__detail-actions">
                      <a href="javascript:void(0)" class="action-edit text-link">Edit</a>
                      <div class="progress-tree__detail-actions-notification">
                        <span><span></span></span>
                      </div>
                    </div>
                  </div>
                }
                @for (group of groups; track group) {
                  <div class="progress-tree__title">
                    <p>{{group.group_name}}</p>
                    <a href="javascript:void(0)" class="action-add text-link">+ Add</a>
                  </div>
                  @for (item of group.items; track item) {
                    <div (click)="activateItem(item)" class="progress-tree__detail"
                      [ngClass]="{'progress-tree__detail--selected': cart_item?.class_id === item?.class_id && cart_item?.item_id === item?.item_id}">
                      <div class="progress-tree__detail-name" title="{{formatItemDescription(item.description, 1)}}">
                        {{formatItemDescription(item.description, 1)}}
                      </div>
                      <div class="progress-tree__detail-description">
                        {{formatItemDescription(item.description, 2)}}
                      </div>
                      <div class="progress-tree__detail-actions is-{{getItemStatus(item.progress, item.has_skipped)}}">
                        <!--<a href="javascript:void(0)" class="action-edit text-link">Edit</a>
                        <span>|</span>-->
                        <a href="javascript:void(0)" class="action-remove text-link" (click)="removeItem(item?.class_id, item?.item_id)">Remove</a>
                        <div class="progress-tree__detail-actions-notification">
                          <span><span></span></span>
                        </div>
                      </div>
                    </div>
                  }
                }
                @if (police_report) {
                  <div class="progress-tree__detail mt-30" (click)="activateItem(police_report)" [ngClass]="{'progress-tree__detail--selected': cart_item?.entry_type === 'police_report_details'}">
                    <div class="progress-tree__detail-name" title="">
                      {{formatItemDescription(police_report.description, 1)}}
                    </div>
                    <div class="progress-tree__detail-description">
                      {{formatItemDescription(police_report.description, 2)}}
                    </div>
                    <div class="progress-tree__detail-actions is-pending">
                      <a href="javascript:void(0)" class="action-edit text-link">Edit</a>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>

      <div class="layout__main">
        <!--<app-event-details *ngIf="modal_type === ModalTypes.event_details" [cart_item]="cart_item" [showItemDetails]="modal_type === ModalTypes.item_details"></app-event-details>-->
        <app-clam-edit-event-details
          [cart_item]="cart_item"
          [showItemDetails]="modal_type === ModalTypes.item_details"
          [display_type]="modal_type"
          (removeItem)="onRemoveItemChange($event)">
        </app-clam-edit-event-details>
        <!--<app-item-details *ngIf="modal_type === ModalTypes.item_details" [cart_item]="cart_item"></app-item-details>-->
      </div>
    </div>
  </div>
</main>

<app-disclaimer></app-disclaimer>

<footer class="question-tray">
  <div class="container">
    <div class="question-tray__controls">
      <div class="question-tray__btns">
        <a href="javascript:void(0);" (click)="back()" class="button button--lg button--secondary">Cancel</a>
        <a href="javascript:void(0);" (click)="save()" class="button button--lg button--primary">{{ claim_details?.claim_completion_status_id === 4 ? 'Register' : 'Save' }}</a>
      </div>
    </div>
  </div>
</footer>

<div class="modal fade modal--tray" id="modal-submenu" tabindex="-1" role="dialog" aria-labelledby="modal-submenu" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu modal-traymenu--fs">
      <div class="modal-traymenu__header modal-traymenu__header--no-bdr">
        <div class="container">
          <a href="javascript:void(0)" (click)="closeSubModal()" class="modal-traymenu__header-close">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </a>
        </div>
      </div>

      <div class="modal-traymenu__content pt-0">

        <div class="container card-body-edit mt-15">

          @for (item of event_details?.items; track item) {
            <div class="claim-summary-card claim-summary-card--sm" (click)="activateItem(item)"
              [ngClass]="{'claim-summary-card--active': cart_item?.class_id === item?.class_id && cart_item?.entry_type != 'police_report_details'}">
              <div class="claim-summary-card__image">
                <img src="assets/img/claims/event-crash-temp.svg" class="icon">
                <img src="assets/3/icn/claims-shield.svg" class="icon-secondary">
              </div>
              <div class="progress-tree__detail-description">
                <h5 class="text-color-dark mb-4">{{item.name}}</h5>
                <p>{{item.location}}</p>
                <p class="progress-tree__detail-date">{{item.date}}</p>
              </div>
              <div class="progress-tree__detail-actions">
                <a href="javascript:void(0)" class="action-edit text-link">Edit</a>
                <div class="progress-tree__detail-actions-notification">
                  <span><span></span></span>
                </div>
              </div>
            </div>
          }

          @for (group of groups; track group) {
            <div class="progress-tree__title">
              <p>{{group.group_name}}</p>
              <a href="javascript:void(0)" class="action-add text-link">+ Add</a>
            </div>
            @for (item of group.items; track item) {
              <div (click)="activateItem(item)" class="progress-tree__detail"
                [ngClass]="{'progress-tree__detail--selected': cart_item?.class_id === item?.class_id && cart_item?.item_id === item?.item_id}">
                <div class="progress-tree__detail-name" title="{{formatItemDescription(item.description, 1)}}">
                  {{formatItemDescription(item.description, 1)}}
                </div>
                <div class="progress-tree__detail-description">
                  {{formatItemDescription(item.description, 2)}}
                </div>
                <div class="progress-tree__detail-actions is-{{getItemStatus(item.progress, item.has_skipped)}}">
                  <a href="javascript:void(0)" class="action-remove text-link">Remove</a>
                  <div class="progress-tree__detail-actions-notification">
                    <span><span></span></span>
                  </div>
                </div>
              </div>
            }
          }

          @if (police_report) {
            <div class="progress-tree__detail mt-30" (click)="activateItem(police_report)" [ngClass]="{'progress-tree__detail--selected': cart_item?.entry_type === 'police_report_details'}">
              <div class="progress-tree__detail-name" title="">
                {{formatItemDescription(police_report.description, 1)}}
              </div>
              <div class="progress-tree__detail-description">
                {{formatItemDescription(police_report.description, 2)}}
              </div>
              <div class="progress-tree__detail-actions is-pending">
                <a href="javascript:void(0)" class="action-edit text-link">Edit</a>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
